<section>
  <div id="slider">
    <div id="headerSlider" class="carousel slide" data-ride="carousel">
      <!-- <ol class="carousel-indicators">
        <li data-target="#headerSlider" data-slide-to="0" class="active"></li>

      </ol> -->
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img alt="banner" src="../assets/images/banner1.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <div class="banner-text">
              <!-- <h4 class="">Our Three Pillars</h4> -->
              <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
              <h2>{{state}}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="cities">
  <div class="container">
    <h1 class="heading text-center">Our Offices in {{state}}</h1>
    <div class="row">
      <ng-container *ngFor="let city of cities">
        <div class="col-md-6 col-lg-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{city.city +", " + state}}</h4>
              <hr>

              <p class="card-text">
                <i class="fas fa-map-marked"></i> {{city.office_address}}
              </p>
              <p></p>
              <div class="call-card">
                <a href="tel:+1{{city.phone_number}}" class="card-link call"><span class="phone-number"><i class="fas fa-phone"></i> {{city.phone_number}}</span></a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- <ng-container *ngFor="let userDetail of userDetails">
        <div class="col-md-6 col-lg-4" >
          <app-user-item [userDetail]="userDetail"></app-user-item>
        </div>
      </ng-container> -->
    </div>
  </div>

</section>
